export type TransportOrderedInfo = {
    STATUS?: string | null;
    TRACKING_NUMBER?: string | null;
};

/** A shipment already exists at the carrier: ordering again must be forced (new shipment and label). */
export const isTransportAlreadyOrdered = (transport?: TransportOrderedInfo | null): boolean => {
    if (!transport) {
        return false;
    }
    if ((transport.TRACKING_NUMBER ?? '').trim()) {
        return true;
    }
    return Boolean(transport.STATUS) && transport.STATUS !== 'created' && transport.STATUS !== 'incorrect';
};
